export const USER = 'user';
export const GUEST = 'guest';
export const ADMINISTRATOR = 'administrator';
export const GLOBAL_ADMINISTRATOR = 'global_administrator';
export const MODERATOR = 'moderator';
export const GLOBAL_MODERATOR = 'global_moderator';
